export default "__VITE_ASSET__3c717e01__"